import axios from "axios";

let baseUrl;

if (
  window.location.origin === "http://localhost:3000" ||
  window.location.origin === "http://localhost:3001"
) {
  baseUrl = "http://127.0.0.1:8000/";
  // baseUrl = "https://erp.anzaraltd.com/";
  // baseUrl = window.location.origin;
} else {
  if (window.location.origin === "https://erp.azranbd.com" ||
    window.location.origin === "erp.azranbd.com") {
    // baseUrl = "https://azran.up.railway.app/";
    baseUrl = window.location.origin;
  } else if (window.location.origin === "https://erp.elorbd.com" ||
    window.location.origin === "erp.elorbd.com") {
    // baseUrl = "https://elor.up.railway.app/";
    baseUrl = window.location.origin;
  } else if (window.location.origin === "https://anzara-accounting.vercel.app" ||
    window.location.origin === "anzara-accounting.vercel.app") {
    baseUrl = "https://anzara-ltd-backend-production.up.railway.app/";
    // baseUrl = window.location.origin;
  } else {
    baseUrl = window.location.origin;
  }

}
export default axios.create({
  baseURL: baseUrl,
});
